<template>
    <Default-Layout>
        <div class="container organizaciones" v-if="emailVerify">
            <modal name="modal-org" height="auto" @before-close="beforeClose">
                <div class="card-header">{{ $t("lang.label_new_org") }}</div>
                <div class="card-body">
                    <form
                        @submit.prevent="saveOrg"
                        enctype="multipart/form-data"
                        id="form1"
                    >
                        <div class="row">
                            <div class="col-12">
                                <div class="estilosform">
                                    <div class="row">
                                        <div class="col-md-3 text-right marginTop">
                                            <label for="" class="col-form-label"
                                                >{{ $t("lang.label_name_org") }}
                                            </label>
                                        </div>
                                        <div class="col-md-9 marginTop">
                                            <input
                                                type="text"
                                                class="form-control"
                                                id=""
                                                v-model="FormCompanyInfo.companyname"
                                                required
                                            />
                                        </div>
                                        <div class="col-md-3 text-right marginTop">
                                            <label for="" class="col-form-label">{{
                                                $t("lang.label_fname")
                                            }}</label>
                                        </div>
                                        <div class="col-md-9 marginTop">
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="FormCompanyInfo.firstname"
                                            />
                                        </div>
                                        <div class="col-md-3 text-right marginTop">
                                            <label for="" class="col-form-label">{{
                                                $t("lang.label_lname")
                                            }}</label>
                                        </div>
                                        <div class="col-md-9 marginTop">
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="FormCompanyInfo.lastname"
                                            />
                                        </div>
                                        <div class="col-md-3 text-right marginTop">
                                            <label for="" class="col-form-label">{{
                                                $t("lang.label_adress")
                                            }}</label>
                                        </div>
                                        <div class="col-md-9 marginTop">
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="FormCompanyInfo.address"
                                            />
                                        </div>
                                        <div class="col-md-3 text-right marginTop">
                                            <label for="" class="col-form-label">{{
                                                $t("lang.label_city")
                                            }}</label>
                                        </div>
                                        <div class="col-md-9 marginTop">
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="FormCompanyInfo.city"
                                            />
                                        </div>
                                        <div class="col-md-3 text-right marginTop">
                                            <label for="" class="col-form-label">{{
                                                $t("lang.label_state")
                                            }}</label>
                                        </div>
                                        <div class="col-md-9 marginTop">
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="FormCompanyInfo.state"
                                            />
                                        </div>
                                        <div class="col-md-3 text-right marginTop">
                                            <label for="" class="col-form-label">{{
                                                $t("lang.label_zip")
                                            }}</label>
                                        </div>
                                        <div class="col-md-9 marginTop">
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="FormCompanyInfo.zipcode"
                                            />
                                        </div>
                                        <div class="col-md-3 text-right marginTop">
                                            <label for="" class="col-form-label">{{
                                                $t("lang.label_telephone")
                                            }}</label>
                                        </div>
                                        <div class="col-md-9 marginTop">
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="FormCompanyInfo.telephone"
                                            />
                                        </div>
                                        <div class="col-md-3 text-right marginTop">
                                            <label for="" class="col-form-label">
                                                {{ $t("lang.msj_email") }}</label
                                            >
                                        </div>
                                        <div class="col-md-9 marginTop">
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="FormCompanyInfo.email"
                                            />
                                            <span
                                                v-if="emailInvalid"
                                                class="alert alert-danger"
                                                style="padding: 5px"
                                            >
                                                {{ $t("lang.msj_valid_email") }}
                                            </span>
                                        </div>
                                        <div class="col-md-3 text-right marginTop">
                                            <label for="" class="col-form-label">{{
                                                $t("lang.label_website")
                                            }}</label>
                                        </div>
                                        <div class="col-md-9 marginTop">
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="FormCompanyInfo.website"
                                            />
                                        </div>
                                        <div class="col-md-12">
                                            <div
                                                style="
                                                    margin-top: 15px;
                                                    display: flex;
                                                    justify-content: flex-end;
                                                "
                                            >
                                                <button
                                                    type="submit"
                                                    class="btn btn-success"
                                                    style="margin-right: 10px"
                                                >
                                                    {{ $t("lang.label_save") }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </modal>
        </div>
    </Default-Layout>
</template>

<script>
import axios from "axios";
import DefaultLayout from "@/Layouts/Account/DefaultLayout";
export default {
    name: "Organizations",
    components: {
        DefaultLayout,
    },
    data () {
        return {
            isloaing: false,
            organizationslist: [],
            FormCompanyInfo: {
                id: null,
                title: null,
                action: null,
                companyname: null,
                firstname: null,
                lastname: null,
                address: null,
                city: null,
                state: null,
                zipcode: null,
                telephone: null,
                email: null,
                website: null,
            },
            org_id: 0,
            org_id_old: 0,
            emailInvalid: false,
            emailVerify: window.emailVerify,
        }
    },
    mounted() {
        this.showmodal();
    },
    created() {
        if (window.user_type == 2) {
            this.$router.push({ name: "Home" });
        }
    },
    methods: {
        beforeClose() {
            this.$router.push({ name: "Organizations" });
        },
        showmodal() {
            console.log("abrir modal", window.emailVerify);
            this.$modal.show("modal-org");
            this.FormCompanyInfo.title = window.lang2.label_add;
            this.FormCompanyInfo.action = window.lang2.label_add;
            this.FormCompanyInfo.id = null;
            this.FormCompanyInfo.companyname = null;
            this.FormCompanyInfo.firstname = null;
            this.FormCompanyInfo.lastname = null;
            this.FormCompanyInfo.address = null;
            this.FormCompanyInfo.city = null;
            this.FormCompanyInfo.state = null;
            this.FormCompanyInfo.zipcode = null;
            this.FormCompanyInfo.telephone = null;
            this.FormCompanyInfo.email = null;
            this.FormCompanyInfo.website = null;
            this.emailInvalid = false;
        },
        saveOrg() {
            let re = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
            if (!re.test(this.FormCompanyInfo.email)) {
                this.emailInvalid = true;
                console.log("formato de email invalid");
            } else {
                this.emailInvalid = false;
                this.isloaing = true;
                console.log("save");
                window.master
                    .post("organization/" + window.localAccountID, {
                        user_id: window.localAccountID,
                        companyname: this.FormCompanyInfo.companyname,
                        firstname: this.FormCompanyInfo.firstname,
                        lastname: this.FormCompanyInfo.lastname,
                        address: this.FormCompanyInfo.address,
                        city: this.FormCompanyInfo.city,
                        state: this.FormCompanyInfo.state,
                        zipcode: this.FormCompanyInfo.zipcode,
                        telephone: this.FormCompanyInfo.telephone,
                        website: this.FormCompanyInfo.website,
                        email: this.FormCompanyInfo.email,
                    })
                    .then((response) => {
                        this.isloaing = false;
                        if (response.data.status) {
                            this.$modal.hide("modal-org");
                            this.$swal.fire({
                                type: "success",
                                title: window.lang2.msj_add_org_sful,
                                showConfirmButton: false,
                                timer: 2000,
                            });
                            this.$router.push({ name: "Organizations" });
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        this.isloaing = false;
                    });
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.change-org {
    position: absolute;
    right: -9px;
    top: 16px;
    border: 0;
    background-color: transparent;
}
.icontri {
    position: absolute;
    top: -21px;
    left: 50%;
    display: block;
    width: 0;
    height: 0;
    border-right: 10px solid transparent;
    border-top: 10px solid transparent;
    border-left: 10px solid transparent;
    border-bottom: 10px solid #a1e0ae;
    transform: translateX(-50%);
}
.prof_title {
    display: block;
    font-size: 14px;
}
.prof_title h4 {
    font-weight: 100;
    font-size: 24px;
    text-align: center;
}
.organizaciones {
    margin-top: 60px !important;
}
.organizaciones label {
    display: block;
    margin-bottom: 0.1rem;
}
.on ion-icon {
    display: inline-block;
    color: #4bcc66;
    font-size: 20px;
    vertical-align: sub;
}
.off ion-icon {
    display: inline-block;
    color: #a4a6a9;
    font-size: 20px;
    vertical-align: sub;
}
.estilosform label {
    font-size: 14px;
}
.estilosform .marginTop {
    margin-bottom: 8px;
}
.v--modal-overlay {
    z-index: 9999 !important;
}
</style>
